<template>
    <el-container>
        <el-header>
            <Header />
        </el-header>
        <el-main>
            <div class="custome-service">
                <div class="service-item">
                    <el-tooltip class="item" effect="light" content="Top Center 提示文字" placement="left" trigger="click" :hide-after="30000" ref="weixintooltip">
                        <div slot="content">
                            <p class="tooltip-title">扫码添加微信客服</p>
                            <img src="../assets/images/weichat.png" alt="" style="width:177px;height:177px">
                        </div>
                        <div>
                           <svg t="1702450777182" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6801" width="48" height="48"><path d="M499.057025 347.95532c27.691946 0 45.751911-18.661964 45.751911-45.751911 0-27.089947-18.661964-45.751911-45.751911-45.751911-26.487948 0-54.781893 17.457966-54.781893 45.751911C444.275132 329.895356 472.569077 347.95532 499.057025 347.95532z" p-id="6802" fill="#515151"></path><path d="M299.795414 301.601411c0-27.089947-18.661964-45.751911-45.751911-45.751911-26.487948 0-54.781893 17.457966-54.781893 45.751911 0 28.293945 28.293945 45.751911 54.781893 45.751911C281.73545 347.95532 299.795414 329.293357 299.795414 301.601411z" p-id="6803" fill="#515151"></path><path d="M1024 625.476778c0-67.423868-30.099941-132.439741-84.279835-183.007643-53.577895-49.965902-125.215755-80.667842-201.067607-87.28983 0-1.203998 0-2.407995 0-3.611993-31.905938-148.091711-190.833627-260.063492-370.229277-260.063492C164.947678 91.503821 0 232.973545 0 406.951205 0 499.659024 46.955908 583.938859 136.653733 649.556731l-30.70194 92.707819c-2.407995 7.223986 0 14.447972 5.417989 19.263962 5.417989 4.815991 13.845973 5.417989 19.865961 2.407995l116.787772-58.393886 13.845973 3.009994 0.601999 0c36.119929 7.223986 67.423868 13.845973 105.951793 13.845973 7.223986 0 34.915932-2.407995 43.945914-6.621987 44.547913 108.359788 163.74368 181.201646 297.387419 181.201646 33.711934 0 68.025867-7.825985 102.3398-16.253968l89.697825 48.761905c2.407995 1.203998 5.417989 2.407995 8.427984 2.407995 4.213992 0 8.427984-1.203998 11.437978-4.213992 6.019988-4.815991 7.825985-12.039976 6.019988-19.263962l-22.875955-75.249853C981.258083 772.364491 1024 698.318636 1024 625.476778zM864.470312 803.66843c-6.019988 4.213992-8.427984 12.039976-6.019988 18.661964l12.641975 42.741917-54.179894-29.497942c-2.407995-1.203998-5.417989-2.407995-8.427984-2.407995-1.203998 0-3.009994 0-4.213992 0.601999-31.303939 7.825985-63.811875 16.253968-95.717813 16.253968-146.285714 0-265.481481-100.533804-265.481481-223.943563 0-123.409759 119.195767-223.943563 265.481481-223.943563 143.877719 0 264.879483 102.3398 264.879483 223.943563C974.034098 687.482657 935.506173 750.692534 864.470312 803.66843zM181.803645 640.526749c2.407995-7.223986 0-15.049971-6.621987-19.865961C90.901822 561.664903 48.159906 490.027043 48.159906 407.553204 48.159906 258.859494 191.435626 137.857731 367.821282 137.857731c154.111699 0 291.96943 93.911817 322.069371 218.525573-164.345679 3.611993-297.387419 120.399765-297.387419 261.869489 0 18.661964 2.407995 37.925926 7.825985 57.189888-0.601999 0-1.805996 0-2.407995 0-9.631981 0.601999-19.865961 1.203998-30.099941 1.203998-34.313933 0-63.811875-6.019988-95.717813-12.641975l-19.263962-3.611993c-3.611993-0.601999-7.825985 0-11.437978 1.203998l-80.065844 40.333921L181.803645 640.526749z" p-id="6804" fill="#515151"></path><path d="M612.834803 509.893004c-18.661964 0-37.323927 18.661964-37.323927 37.323927 0 18.661964 18.661964 37.323927 37.323927 37.323927 28.293945 0 45.751911-19.263962 45.751911-37.323927C658.586714 529.156966 641.128748 509.893004 612.834803 509.893004z" p-id="6805" fill="#515151"></path><path d="M804.872428 509.893004c-18.661964 0-36.721928 18.661964-36.721928 37.323927 0 18.661964 18.059965 37.323927 36.721928 37.323927 28.293945 0 45.751911-19.263962 45.751911-37.323927C850.624339 529.156966 833.166373 509.893004 804.872428 509.893004z" p-id="6806" fill="#515151"></path></svg>
                             <p class="service-title">微信咨询</p>
                        </div>
                    </el-tooltip>
                </div>
                <div class="service-line"></div>
                <div class="service-item">
                     <el-tooltip class="item" effect="light" content="Top Center 提示文字" placement="left" trigger="click" :hide-after="30000" ref="weixintooltip">
                        <div slot="content">
                            <p class="tooltip-title">扫一扫加入官方技术群</p>
                            <img src="../assets/images/QQ.png" alt="" style="width:177px;height:177px">
                        </div>
                        <div>
                            <svg t="1702450690725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4568" width="48" height="48"><path d="M848 848a32 32 0 1 1 0 64H176a32 32 0 1 1 0-64h672z m48-736a64 64 0 0 1 64 64v512a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V176a64 64 0 0 1 64-64h768z m0 64H128v512h768V176z" fill="#707070" p-id="4569"></path><path d="M624.672 272l113.792 114.288L784 432l-159.328 160-45.536-45.712 113.808-114.304-113.808-114.272L624.672 272z m-225.344 0l45.536 45.712L331.04 432l113.824 114.288L399.328 592l-113.808-114.304v0.016L240 432l159.328-160z" fill="#707070" p-id="4570"></path></svg>
                            <p class="service-title">技术支持</p>
                        </div>
                    </el-tooltip>
                    
                </div>
                <div class="service-line"></div>
                <div class="service-item">

                     <el-tooltip class="item" effect="light" content="Top Center 提示文字" placement="left" trigger="click" :hide-after="30000" ref="weixintooltip">
                        <div slot="content">
                            <p class="tooltip-title">扫码关注官方微信公众号</p>
                            <img src="../assets/images/publicwx.jpg" alt="" style="width:177px;height:177px">
                        </div>
                        <div>
                            <span  class="iconfont icon-kefu"></span>
                            <p class="service-title">微信公众号</p>
                        </div>
                    </el-tooltip>
                   
                </div>
            </div>
            <router-view></router-view>
        </el-main>
        <el-footer style="height:70px;position:relative">
            <Footer/>
        </el-footer>
        <el-dialog
                title=""
                :visible.sync="dialogVisible"
                width="20%"
                :before-close="handleClose">
                <p style="margin-bottom:10px">扫码添加客服微信</p>
                <img src="../assets/images/weichat.png" alt="" style="width:177px;height:177px">
        </el-dialog>
    </el-container>
   
        

</template>

<script>
import { h } from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
    export default {
        name:'layout',
        components:{
            Header,
            Footer
        },
        data () {
            return {
                dialogVisible:false
            }
        },
        mounted() {
            this.init();

        },
        methods: {

            init(){
                let that = this;
                this.$notify({
                    title: '活动通知',
                    duration:0,
                    type: 'success',
                    dangerouslyUseHTMLString: true,
                    message: '<span class="message-tip">扫码联系客服，获取企业版Docker镜像，本地轻松部署和体验。</span>',
                    onClick() {
                        that.dialogVisible = true;
                    }
                });
            },
            add(){

            },
            edit(){

            },
            handleClose(){
                this.dialogVisible = false;
            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less">
.el-header{
    height: 66px!important;
    position: fixed;
    top: 0;
    width: 100%;
    background: #e6ebf6;
    z-index: 999;
}
.el-main{
    margin:0;
    padding: 0;
    overflow: initial;
    display: table;
}
.el-footer{
    height:auto;
    padding:0;
    width:100%;
}

.custome-service{
    position: fixed;
    right: 0px;
    top: 35%;
    z-index: 999;
    width: 73px;
    font-size: 20px;
    text-align: center;
    background: #fff;
    box-shadow: 0 0 10px 2px #bcb6b6;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding: 20px 0 20px 10px;
    .service-item{
        cursor: pointer;
    }
    .service-line{
        width: 42px;
        height: 1px;
        background: #CCCCCC;
        margin:0 auto;
        margin-top:20px;
        margin-bottom:20px;
    }
    .iconfont{
        font-size: 40px;
    }
    .tooltip-title{
        margin-bottom: 10px;
    }
    .service-title{
        font-size: 12px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #939393;
        margin-top:6px;
    }
}
.banner-conainer,.version-conainer{
        background-image: url('../assets/images/banner.png');
        height: 850px;
        background-size: 100% 100%;
        overflow: hidden;
        background-repeat: no-repeat;
        // background-position: 0 -188px;
        .main-banner{
            width: 1200px;
            margin: 0 auto;
            margin-top: 230px;
            text-align:left;
            .banner-btn{
                margin-top:50px;
            }
        }
        .block-text{
            .block-title{
                font-size: 50px;
                font-family: Alibaba PuHuiTi;
                font-weight: bold;
                color: #1E1E1E;
                line-height: 76px;
                width: 700px;
                text-align: left;
            }
            .block-desc{
                width: 570px;
                // height: 78px;
                font-size: 16px;
                font-family: Alibaba PuHuiTi;
                font-weight: 400;
                color: #3D3D3D;
                line-height: 30px;
                // opacity: 0.95;
                text-align: left;
                margin-top:33px;
            }
        }
    }

    .card-title{
        font-size: 50px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #3D3D3D;
    }
    .message-tip{
        line-height:1.3;
    }
</style>